/**
 * Stable DOM id for a rendered thread message, so the conversation can scroll to one by message id.
 * Prefixed because Gmail message ids are bare hex and would otherwise collide with anything else on
 * the page that ids itself the same way.
 */
export const messageAnchorId = (messageId: string) => `message-${messageId}`;
